import { objectToFormData } from 'object-to-formdata'
import store from '../store'

const options = {
  indices: true,
}

export function incrementLoadingCount(config) {
  store.commit('incrementLoadingCount')
  return config
}

export function decrementLoadingCount(callback) {
  const { config } = callback
  if (!config) {
    return callback
  }
  setTimeout(() => {
    store.commit('decrementLoadingCount')
  }, 100)

  return callback
}

export function resetLoadingCount(callback) {
  setTimeout(() => {
    store.commit('clearLoadingCount')
  }, 200)

  return callback
}

export function handleUnAuthorized(error) {
  if (error.response && error.response.status === 401) {
    resetLoadingCount()
    window.replace = '/admin/'
  }

  return Promise.reject(error)
}

export function handleForbidden(error) {
  if (error.response && error.response.status === 403) {
    resetLoadingCount()
    store.commit(
      'setSystemMessage',
      { message: 'アクセス権限がありません。' },
    )
  }

  return Promise.reject(error)
}

export function handleNotFound(error) {
  if (error.response && error.response.status === 404) {
    resetLoadingCount()
    store.commit(
      'setSystemMessage',
      { message: 'URLが見つかりません。' },
    )
  }

  return Promise.reject(error)
}

export function handleTooManyRequests(error) {
  if (error.response && error.response.status === 429) {
    resetLoadingCount()
    store.commit(
      'setSystemMessage',
      { message: 'ただいま混み合っています。しばらく経ってからアクセスしてください。' },
    )
  }

  return Promise.reject(error)
}

export function handleValidationError(error) {
  if (error.response && error.response.status === 422) {
    resetLoadingCount()
    const { errors } = error.response.data

    if (Object.prototype.hasOwnProperty.call(errors, 'confirmed')) {
      if (Object.keys(errors).length === 1) {
        return null
      }
      delete errors.confirmed
    }
    store.commit(
      'setSystemMessage',
      {
        message: Object.values(errors).join('\n'),
        color: 'warning',
        light: false,
        title: '入力エラー',
        icon: 'mdi-alert',
      },
    )
  }

  return Promise.reject(error)
}

export function handleServerError(error) {
  if (error.response && error.response.status === 500) {
    resetLoadingCount()
    store.commit(
      'setSystemMessage',
      { message: 'システムエラーが発生しました。' },
    )
  }

  return Promise.reject(error)
}

export const toFormData = (data) => {
  const sanitizedData = data

  Object.keys(data).forEach((key) => {
    if (Array.isArray(data[key]) && data[key].length === 0) {
      delete sanitizedData[key]
    }
  })

  return objectToFormData(sanitizedData, options)
}

export default toFormData
